// Defaults
import React, { useMemo } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { FindifyLoadingScreen } from "../genericPages/components/FindifyLoadingScreen";
import { useAppRoutes } from "../genericPages/hooks/useAppRoutes";

// GenericPages
import { PlaceTab } from "./hometabs/PlaceTab";
import { ProfileTab } from "../genericPages/ProfileTab";
import { ScanTab } from "./hometabs/ScanTab";
import { StoreTab } from "./hometabs/StoreTab";
import { ScanRATab } from "../genericPages/ScanRA";
import { ARVideoPlayerTab } from "../genericPages/ARVideoPlayer";
import { ScanQrTab } from "../genericPages/ScanQr";
import { PlaceMapTab } from "../genericPages/PlaceMap";
import { PlaceInfoTab } from "../genericPages/PlaceInfo";
import { PlaceContentDetailsTab } from "../genericPages/PlaceContentDetails";
import { PlaceContentListTab } from "./hometabs/PlaceTabs/PlaceContentsList";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { WebViewPage } from "../genericPages/WebViewPage";
import { TicTacToePage } from "../genericPages/TicTacToePage";
import { MemoryGamePage } from "../genericPages/MemoryGamePage";
import { GallerySlidePage } from "../genericPages/GallerySlidePage";
import { SchedulePage } from "./hometabs/SchedulePage";
import { PlantsPage } from "./hometabs/PlantsPage";
import { TicketsListZonePage } from "../genericPages/TicketsListZone";
import { EventTicketZone } from "../genericPages/EventTicketCollectionZone";
import { EventTicketsZone } from "../genericPages/EventTicketsZone";
import { CheckoutPage } from "../genericPages/CheckoutPage";
import { UserTicketsPage } from "../genericPages/UserTicketsPage";
import { UserOrdersPage } from "../genericPages/UserOrdersPage";
import { AdminZone } from "../genericPages/adminZone/AdminZone";
import { AdminTicketValidation } from "../genericPages/adminZone/AdminTicketValidation";


// const Stack = createStackNavigator();
const Stack = createNativeStackNavigator();

export type GenericRoute = {
    path: string,
    component: any
}
export const genericRoutes = (overrides: GenericRoute[]): GenericRoute[] => {
    // Make child rows have parent name prefix 
    const baseRoutes: GenericRoute[] = [
        // FIRST PAGE IN STACK IS DEFAULT PAGE 
        { path: "Place", component: PlaceTab }, // ENTRY PAGE 
        // Stack 
        { path: "PlaceMap", component: PlaceMapTab },
        { path: "PlaceInfo", component: PlaceInfoTab },
        { path: "PlaceContentList", component: PlaceContentListTab },
        { path: "PlaceContentDetails", component: PlaceContentDetailsTab },
        { path: "GallerySlidePage", component: GallerySlidePage },
        // ScanPages 
        { path: "Scan", component: ScanTab },
        { path: "ScanRA", component: ScanRATab },
        { path: "ARVideoPlayer", component: ARVideoPlayerTab },
        { path: "ScanQR", component: ScanQrTab },
        // Store Pages 
        { path: "Store", component: StoreTab },
        // Profile Pages 
        { path: "Profile", component: ProfileTab },
        { path: "UserTickets", component: UserTicketsPage },
        { path: "UserOrders", component: UserOrdersPage },
        // WebviewPage 
        { path: "WebViewPage", component: WebViewPage },
        { path: "TicTacToePage", component: TicTacToePage },
        { path: "MemoryGamePage", component: MemoryGamePage },
        // SchedulePage 
        { path: "SchedulePage", component: SchedulePage },
        { path: "PlantsPage", component: PlantsPage },
        // TicketsListZonePage 
        { path: "TicketsListZonePage", component: TicketsListZonePage },
        { path: "EventTicketsPage", component: EventTicketsZone },
        { path: "EventTicketPage", component: EventTicketZone },
        // CheckoutPage 
        { path: "CheckoutPage", component: CheckoutPage },
        // AdminZone
        { path: "AdminZone", component: AdminZone },
        { path: "AdminTicketValidation", component: AdminTicketValidation },
    ]

    const mergedArray = baseRoutes.slice();

    overrides.forEach((override) => {
        const index = mergedArray.findIndex(baseObj => baseObj.path === override.path);
        if (index !== -1) {
            // Replace the object in the base array with the one from the overrides array
            mergedArray[index] = override;
        } else {
            // If no object with the same name found in the base array, just push the override object
            mergedArray.push(override);
        }
    });

    return mergedArray;
}
export const PlaceApp = () => {
    const { lodadedInitialData, placeRoutes, findifyDataContext } = useAppRoutes([]);

    if (!lodadedInitialData) return <FindifyLoadingScreen />

    return <Stack.Navigator
        screenOptions={{
            animation: 'fade',
            animationTypeForReplace: 'pop',
            animationDuration: 100,
            headerShown: false,
            statusBarColor: PlaceColors(findifyDataContext).background.withAlpha(180),
            headerTintColor: PlaceColors(findifyDataContext).background.withAlpha(180),
            navigationBarColor: PlaceColors(findifyDataContext).background.get(),
        }}
    >
        {placeRoutes.map((route: any) => {
            return <Stack.Screen key={route.path} name={route.path} component={route.component} />
        })}
    </Stack.Navigator>

}
